import React from "react";
import { useHistory } from "react-router-dom";
import { User } from "../../storage/store";
import AppDeviceCard from "./app/AppDeviceCard";
import { MODELS, isModel, typeOf } from "../../constants/devices";

// Gate, water level and curtain controllers. As in the app, the card only opens
// the controls; it no longer sends a command when clicked, and the WGC_1 and
// WGC_2 gate controllers always show their gate colour with white text.
const ControllerCard = ({ props }) => {
  const device = props;
  const navigate = useHistory();

  return (
    <AppDeviceCard
      name={device.name}
      floor={device.floor}
      room={device.room}
      timeStamp={device.props?.timeStamp}
      type={typeOf(device)}
      active={device.props?.state === true}
      alwaysColoured={isModel(device, MODELS.WGC_1, MODELS.WGC_2)}
      onOpen={() => navigate.push("/device", { data: device, propertyId: User.getPropertyId() })}
    />
  );
};

export default ControllerCard;
